/**
 * PLT-7087 — the product editor in the product set card autosaves without a chat turn, so nothing in
 * the thread records the edit. It announces each save here, and the company's newest product set card
 * re-reads the set (`use-product-set-card-payload.ts`).
 *
 * Module-level rather than React context: a card and the editor it opens can sit in different
 * messages of the thread, and the newest card for a company is not necessarily the one being edited.
 */

type ProductSetSavedListener = (companyId: string) => void;

const listeners = new Set<ProductSetSavedListener>();

/** Returns the unsubscribe function. */
export function subscribeProductSetSaved(fn: ProductSetSavedListener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

export function notifyProductSetSaved(companyId: string): void {
  for (const fn of listeners) fn(companyId);
}
